import { Div, Collection, Ref, TableBuilder, Checkbox } from "@tblabs/truffle";
import { BasketItem } from "../../../../Models/Basket/BasketItem";
import { AdminBasketTableItem } from "../../OrdersView/Views/Table/Components/BasketTableItem";


export class BasketItemsSelector extends Div
{
    constructor(basketItems: BasketItem[], selectedItems: Collection<string>)
    {
        super();

        const items = [...basketItems.map(x => ({
            Item: x,
            Selected: new Ref<boolean>(selectedItems.Contains(x.Id))
        }))];

        this.Append(
            new TableBuilder(items)
                .AddColumn("", item =>
                    new Checkbox(item.Selected)
                        .OnChange(() => selectedItems.Contains(item.Item.Id)
                            ? selectedItems.Remove(item.Item.Id)
                            : selectedItems.Add(item.Item.Id)))
                .AddColumn("", item => new AdminBasketTableItem(item.Item))
                .Build()
        );
    }
}
